import type {CmLogger} from "@cm/log"
import {Catalog} from "@cm/pricing/catalogs/catalog-interface"
import {parseXml} from "@cm/pricing/catalogs/darran/maincatalog"
import {parseXlsb} from "@cm/pricing/catalogs/vado/catalog"

//parse: customer-specific parser; if omitted, the parser is guessed from the file extension (xml: Darran, spreadsheets: Vado)
export async function getCatalogFromFileInput(
    event: Event,
    logger: CmLogger,
    parse?: (data: Uint8Array, xlsx: typeof import("xlsx"), logger: CmLogger) => Catalog,
): Promise<Catalog> {
    const input = event.target as HTMLInputElement
    const file = input.files ? input.files[0] : undefined
    if (!file) throw new Error("No file selected")

    if (parse) {
        return parse(new Uint8Array(await readAsArrayBuffer(file)), await import("xlsx"), logger)
    } else if (file.name.endsWith(".xml")) {
        const data = await new Promise<string>((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result as string)
            reader.onerror = () => reject(reader.error)
            reader.readAsText(file)
        })
        return await parseXml(data)
    } else if (file.name.endsWith(".xlsx") || file.name.endsWith(".xlsb") || file.name.endsWith(".ods")) {
        return parseXlsb(new Uint8Array(await readAsArrayBuffer(file)), await import("xlsx"), logger)
    }

    throw new Error("Unsupported file type")
}

function readAsArrayBuffer(file: File): Promise<ArrayBuffer> {
    return new Promise<ArrayBuffer>((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result as ArrayBuffer)
        reader.onerror = () => reject(reader.error)
        reader.readAsArrayBuffer(file)
    })
}
